<div
  class="cookie-banner-wrapper"
  [class.cookie-banner-wrapper__hidden]="!isVisible"
>
  <div class="cookie-banner">
    <div class="cookie-banner__text">
      <div class="cookie-banner__title">
        {{ 'pool.cookie-banner.title' | translate }}
      </div>
      <div class="cookie-banner__description">
        {{ 'pool.cookie-banner.description' | translate }}
        <a
          [attr.href]="policyUrl"
          target="_blank"
          class="cookie-banner__link"
        >
          {{ 'pool.cookie-banner.link' | translate }}
        </a>
      </div>
    </div>
    <div class="cookie-banner__button">
      <lib-button
        class="cookie-banner__accept-button"
        buttonStyle="primary"
        (click)="acceptCookies()"
      >
        {{ 'pool.cookie-banner.accept' | translate }}
      </lib-button>
    </div>
  </div>
</div>
